import homeView from './index.vue'
import searchView from './search.vue'
import dateView from './date.vue'

const routes = {
  path: 'tour',
  name: 'Private/Tour',
  component: homeView,
  redirect: { name: 'Private/Tour/Search' },
  children: [
    {
      path: 'search',
      name: 'Private/Tour/Search',
      component: searchView
    },
    {
      path: 'date',
      name: 'Private/Tour/Date',
      component: dateView
    }
  ]
}

export default routes
